import { render, staticRenderFns } from "./LandlordProfileFees.vue?vue&type=template&id=2d4764d8&scoped=true&"
import script from "./LandlordProfileFees.vue?vue&type=script&lang=js&"
export * from "./LandlordProfileFees.vue?vue&type=script&lang=js&"
import style0 from "./LandlordProfileFees.vue?vue&type=style&index=0&id=2d4764d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4764d8",
  null
  
)

export default component.exports